export class EffectsRenderBuffer {
  canvas;
  offsetX;
  offsetY;

  constructor(canvas = null, offsetX = 0, offsetY = 0) {
    this.canvas = canvas;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
  }

  update({ canvas, offsetX, offsetY }) {
    this.canvas = canvas ?? this.canvas;
    this.offsetX = offsetX ?? this.offsetX;
    this.offsetY = offsetY ?? this.offsetY;
  }
}
